module.exports = __webpack_public_path__ + "static/media/20.672d96a6.webp";